import OBTCheckBox from './OBTCheckBox';

export default OBTCheckBox;